import { render } from "./DefaultSwitchItem.vue?vue&type=template&id=afb15518&scoped=true&ts=true"
import script from "./DefaultSwitchItem.vue?vue&type=script&lang=ts"
export * from "./DefaultSwitchItem.vue?vue&type=script&lang=ts"

import "./DefaultSwitchItem.vue?vue&type=style&index=0&id=afb15518&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afb15518"]])

export default __exports__